import axios from "axios";

const fetchVideoIndexerToken = async () => {

  const url = process.env.REACT_APP_FUNCTION_APP_VIDEO_INDEXER_TOKEN_API_URL;
  
  try {
    const response = await axios.get(url);
    console.log("Video Indexer token response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching Video Indexer token:", error);
    return '';
  }
};

export default fetchVideoIndexerToken;